<!--
 * @Author: LeeHuiXian
 * @version: 
 * @Date: 2020-08-26 11:20:37
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-08-26 11:31:11
 * @FilePath: /goldenSalesMobile/src/components/BlockTitle/index.vue
 * @Description: 
-->
<template>
  <h3 class="block-title">
    <i class="dot left" />
    <span>{{ title }}</span>
    <i class="dot right" />
  </h3>
</template>

<script>
export default {
  name: 'BlockTitle',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .block-title {
    @include flex-box(center, center);
    width: 100%;
    height: 48px;
    margin: 40px auto 20px;

    >span {
      line-height: 48px;
      font-size: 34px;
      margin: 0 20px;
    }

    >.dot {
      position: relative;
      width:12px;
      height:12px;
      border-radius: 50%;
      background: #D8D8D8;

      &.left {
        &::before {
          position: absolute;
          left: -274px;
          top: 50%;
          z-index: 1;
          content: '';
          width: 274px;
          height: 1px;
          background: #D8D8D8;
        }
      }

      &.right {
        &::after {
          position: absolute;
          right: -274px;
          top: 50%;
          z-index: 1;
          content: '';
          width: 274px;
          height: 1px;
          background: #D8D8D8;
        }
      }
    }
  }
</style>